import Footer from "@/components/footer/footer-view";

/**
 * 스토어 푸터 — 메인 의료진용 웹 푸터와 동일한 디자인(언어 선택 · 의료기기 정보 · 이용약관 · 개인정보 처리방침 · 사업자 정보 띠).
 * 환불 정책은 주문서 동의 문구·이용권 선택 모달·공개 페이지(/policy/refund)에서 확인한다.
 */
export default function StoreFooter() {
  return <Footer store />;
}
